import { api1C } from './api';

export const realization1c = (data) => api1C.post('realization', data);